export default {
  props: {
    responsive: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: true
    },
    borderless: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    'no-border-collapse': {
      type: Boolean,
      default: false
    },
    'no-local-sorting': {
      type: Boolean,
      default: true
    },
    'no-sort-reset': {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default: undefined
    },
    fields: {
      type: Array,
      default: undefined
    },
    'sort-by': {
      type: String,
      default: ''
    },
    'sort-direction': {
      type: String,
      default: 'asc'
    },
    busy: {
      type: Boolean,
      default: false
    },
    showEmpty: {
      type: Boolean,
      default: true
    },
    tbodyTrClass: {
      type: Function,
      default: undefined
    },
    'head-variant': {
      type: String
    }
  },
  render (h) {
    return h('b-table', {
      props: Object.assign(this.$attrs, this.$props),
      slots: this.$slots,
      scopedSlots: this.$scopedSlots,
      on: {
        'sort-changed': (context) => this.sortChanged(context)
      }
    })
  },
  methods: {
    sortChanged (context) {
      this.$emit('sortChanged', context)
    }
  }
}
